import axios from 'axios'
import config from './config'
import QueryString from 'query-string'
import lodash from 'lodash'
import FileDownload from 'js-file-download'

const api = {
  token: null,
  errorHandler: null,
  async get (host, uri, queryJSON) {
    return this.request(host, uri + (queryJSON ? '?' + QueryString.stringify(queryJSON) : ''), {method: 'GET'})
  },
  async downloadBIZ (uri, data, method) {
    const res = await this.request(this.host_biz, uri, {method: method || 'POST', responseType: 'blob', data})
    FileDownload(res.data, (data.params || {}).filename || 'result.xlsx')
  },
  async getBIZ (uri, queryJSON) {
    return this.get(this.host_biz, uri, queryJSON)
  },
  async postBIZ (uri, data) {
    return this.request(this.host_biz, uri, {method: 'POST', data})
  },
  async putBIZ (uri, data) {
    return this.request(this.host_biz, uri, {method: 'PUT', data})
  },
  async deleteBIZ (uri, data) {
    return this.request(this.host_biz, uri, {method: 'DELETE', data})
  },
  async request (host, uri, options) {
    options['url'] = host.replace('http:', document.location.protocol) + uri
    options['headers'] = this.getCommonHeaders()
    var that = this
    axios.interceptors.response.use(response => {
      return response
    }, error => {
      return that.onError(error)
    })
    var response = await axios(options)
    return response
  },
  getCommonHeaders () {
    return this.hasToken() ? {'Authorization': `Bearer ${this.token}`} : {}
  },
  hasToken () {
    return this.token !== null
  },
  setToken (t) {
    this.token = t
  },
  onError (error) {
    return (this.errorHandler || function () {})(error)             // eslint-disable-line
  }
}

export default lodash.extend(api, config)



// WEBPACK FOOTER //
// ./src/api/index.js